import { useCallback } from 'react'
import { BIG_ZERO } from '@pancakeswap/utils/bigNumber'
import { useSousChef, useVaultPoolContract } from 'hooks/useContract'
import { DEFAULT_GAS_LIMIT } from 'config'
import { useGasPrice } from 'state/user/hooks'
import { VaultKey } from 'state/types'
import { ChainId } from '@pancakeswap/sdk'

const options = {
  gasLimit: DEFAULT_GAS_LIMIT,
}

const harvestVaultPool = async (poolContract) => {
  return poolContract.claim({ ...options })
}

const harvestPool = async (sousChefContract, gasPrice) => {
  return sousChefContract.deposit('0', { ...options, gasPrice })
}

const harvestPoolBnb = async (sousChefContract, gasPrice) => {
  return sousChefContract.deposit({
    ...options,
    value: BIG_ZERO,
    gasPrice,
  })
}

const useHarvestPool = (sousId, isUsingBnb = false) => {
  const sousChefContract = useSousChef(sousId)
  const gasPrice = useGasPrice()

  const handleHarvest = useCallback(async () => {
    if (isUsingBnb) {
      return harvestPoolBnb(sousChefContract, gasPrice)
    }

    return harvestPool(sousChefContract, gasPrice)
  }, [isUsingBnb, sousChefContract, gasPrice])

  return { onReward: handleHarvest }
}

export const useHarvestVaultPool = (vaultKey: VaultKey, chainId: ChainId) => {
  const poolContract = useVaultPoolContract(vaultKey, chainId)

  const handleHarvest = useCallback(async () => {
    return harvestVaultPool(poolContract)
  }, [poolContract])

  return { onReward: handleHarvest }
}

export default useHarvestPool
